// Update this address after deploying the contract
export const CONTRACT_ADDRESS = "0x7B13727C74879387e642Ab239c0898CF21498583";

// Citrea Testnet Configuration
export const CITREA_TESTNET = {
  chainId: '0x13FB', // 5115 in hex
  chainName: 'Citrea Testnet',
  nativeCurrency: {
    name: 'cBTC',
    symbol: 'cBTC',
    decimals: 18
  },
  rpcUrls: ['https://rpc.testnet.citrea.xyz'],
  blockExplorerUrls: ['https://explorer.testnet.citrea.xyz']
};
